<template>
  <div style="height: 100%;width: 100%;overflow: auto;">
    <van-sticky>
      <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack" right-text="汇总数据" @click-right="openSumData"/>
      <van-dropdown-menu>
        <van-dropdown-item v-model="storeid" :options="selectStoreInfo" @change="selectStoreChange"/>
      </van-dropdown-menu>
    </van-sticky>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div v-for="(item,key) in indibas" :key="key">
          <van-row>
            <van-col span="24" style="background-color: #39a9ed;line-height: 30px;color: white;font-size: 12px">{{ item.accountdate }}</van-col>
          </van-row>
            <div span="24" style="width: 100%;min-height: 50px">
              <van-button type="primary" size="mini" v-for="(val,idx) in item.cardDdDayVos" :key="idx" style="margin-bottom: 10px;" @click="getCardInfoByMemberInfo(val)">{{val.membername}}({{val.number}})</van-button>
            </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <el-dialog title="卡号选择" :visible.sync="dialogVisible">
      <el-table border :data="cardInfos" size="mini" style="text-align: center" @row-click="openBeautyMemberInfo" highlight-current-row class="productTable">
        <el-table-column label="卡号" align="center" prop="cardnumber"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible:false,
      indibas: [],
      storeid:"",
      selectStoreInfo:[],
      loading: false,
      finished: false,
      refreshing: false,
      uppage:1,
      downpage:0,
      cardInfos:[],
    };
  },
  created() {
    //localStorage.setItem("storeid","320c07ba76e94b0d8735aefe4470c07a");
    //localStorage.setItem("token","eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJBTU4wMDAwNDI3MSIsInN1YiI6IjE1MjAxOTgzNzYzIiwiaWF0IjoxNjE3ODY0MDM2LCJleHAiOjE2MTc5NTA0MzZ9.j_3ToOGhLuaI8tneJPhtMpciXcml7nDT2-w0PUh60QY");
    this.storeid=localStorage.getItem("storeid");
    this.getStoreInfo();

    //this.getCardDdInfo(this.downpage);
  },
  methods:{
    getCardInfoByMemberInfo(row) {
      this.$post("beautymanager/getCardInfoByMemberInfo", {memberid: row.memberid,storeid:row.storeid,date:row.accountdate}).then(res => {
        if (res.sucess) {
          let obj = res.object;
          if (obj.length > 1) {
            this.cardInfos=obj;
            this.dialogVisible=true;
          } else {
            this.openBeautyMemberInfo(obj[0]);
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    openSumData(){
        this.$router.push({path:"/beauty31sumdata"});
    },
    openBeautyMemberInfo(row){
      this.$router.push({path:"/beautymemberinfo",query:{
        cardid:row.cardid,
        cardnumber:row.cardnumber,
        memberid:row.memberid,
        membername:row.membername,
        cardtypeid:row.cardtypeid,
        sex:row.sex
      }});
    },
    selectStoreChange(){
      localStorage.setItem("storeid",this.storeid);
      this.uppage=0;
      this.downpage=0;
      this.indibas=[];
      this.onLoad();
    },
    onLoad(){
      this.downpage++;
      this.getCardDdInfo(this.downpage);
    },
    onRefresh(){
      this.uppage--;
      this.getCardDdInfo(this.uppage);
      this.refreshing = false;
    },
    getCardDdInfo(page){
      this.$post("cardmobilereoprt/getCardDdInfo",{storeid:this.storeid,page:page}).then((res)=>{
        if(res.sucess){
          let array=res.object;
          for(let val of array){
            if(page<=0){
              this.indibas.splice(0, 0, val);
              //console.log(this.indibas);
              //this.indibas.push(val);
            }
            else{
              this.indibas.push(val);
            }
          }
          //console.log(this.indibas);
          this.loading = false;
        }
        else{
          this.$dialog.alert({
            title:"提示",
            message:res.message
          });
        }
      })
    },
    getStoreInfo(){
      //let storeid=localStorage.getItem("storeid");
      let staffid=localStorage.getItem("staffid");
      this.$post("store/getStoreByStructsByStaffId",{storeid:localStorage.getItem("parentstoreid"),staffid:staffid}).then((res)=>{
        if(res.sucess){
          this.selectStoreInfo=[];
          let obj=res.object;
          if(obj!=null && obj.length>0){
            for(let val of obj){
              let store=new Object();
              store.text=val.brandname;
              store.value=val.brandid;
              this.selectStoreInfo.push(store);
            }
          }
        }
        else{
          this.$dialog.alert({
            title:"提示",
            message:res.message
          });
        }
      })
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/page/beauty/cardddday31.vue